import * as React from 'react';

import { AutocompleterContext, AutocompleterContextValues } from './AutocompleterContext';

export function useAutocompleterContext(): AutocompleterContextValues {
    return React.useContext(AutocompleterContext);
}
